import _ from 'lodash-es';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import Twitch from '@/pages/intelligence/assets/svg/dataSource/twitch.svg';
import Fbgaming from '@/pages/intelligence/assets/svg/dataSource/fbgaming.svg';
import Youtube from '@/pages/intelligence/assets/svg/dataSource/youtube.svg';
import { getCountryFlag } from '@/pages/home/_config/countries';

export const DOMAINS_CONFIGS: {
  [key: string]: string;
} = {
  twitch: 'Twitch',
  ytg: 'Youtube',
  facebook: 'Facebook',
};

export const PLATFROM_VALUE_LIST = ['twitch', 'ytg', 'facebook'];

/**
 * @description 表格字段处理增加gameId以及color
 * @param list 传入的数据源
 * @returns
 */
export const handleTableDefaultSelectGames = (list: any, pageIndex?: number) => {
  if (!Array.isArray(list)) {
    return [];
  }
  if (!_.isEmpty(list) && !_.isEmpty(pageIndex?.toString()) && pageIndex !== 1) return [];
  return list.map((item, index) => ({
    ...item,
    gameId: item?.user_info?.id || item?.id,
    color: ECHARTSCOLOR[index],
  }));
};

/**
 * @description  表格icon转化
 * @param key 平台key
 * @returns 返回对应的图片以及，名称
 */
export const iconPlatformType = (key: 'twitch' | 'ytg' | 'facebook') => {
  const config = [
    {
      name: 'Twitch',
      key: 'twitch',
      imgUrl: Twitch,
    },
    {
      name: 'Youtube',
      key: 'ytg',
      imgUrl: Youtube,
    },
    {
      name: 'Facebook',
      key: 'facebook',
      imgUrl: Fbgaming,
    },
  ];
  const { imgUrl, name } = (_.find(config, { key }) as { [key in string]: unknown }) || {};
  return { imgUrl, name };
};

export const isDiffClearArr = (arr: any, arrIsKey: { checked: any }[]) => {
  if (!arr) return [];
  const dataSource = [...arr];
  const res = dataSource.map((task, taskIndex) => ({
    relation: task.relation,
    value: task.value,
    children: arrIsKey[taskIndex].checked ? [] : task.children,
  }));
  return res;
};

export const formattingKolSearchList = (data: {}) => {
  const list = data || [];
  const listTmp = list?.map((item) => {
    const descript =
      item?.platform === 'twitch' ? item?.language : item?.platform === 'ytg' ? item?.market : '';
    const img2 = item?.platform === 'ytg' ? getCountryFlag(item?.market_abbre) : undefined;
    return {
      id: item?.id,
      imgSrc: item?.cover,
      lineOneStr: item?.name,
      lineTwoImg: img2,
      lineTwoStr: descript,
      lineTwoImgName: item?.market_abbre,
      showImgTwo: item?.platform === 'ytg',
    };
  });
  return listTmp ?? [];
};

export const formattingGameSearchList = (data: {}) => {
  const list = data || [];
  const listTmp = list?.map((item) => {
    return {
      id: item?.game_id,
      imgSrc: item?.cover,
      lineOneStr: item?.game_name,
      lineTwoImg: getCountryFlag(item.country_abbre),
      lineTwoImgName: item.country_abbre,
      lineTwoStr: item?.publisher,
    };
  });
  return listTmp ?? [];
};

export const getBarOrPieData = (arrlist: any[]) => {
  if (!Array.isArray(arrlist)) return [];
  const res = arrlist?.map((task) => ({
    app_id: task.user_info.id,
    image_url: task.user_info.icon,
    name: task.user_info.name,
    ipo_status: task.user_info.market,
    location_identifiers_country_code: task.user_info.market_abbre,
    source_metric_list: [
      {
        metric: 'total_revenue',
        value: task.metric_chart.value ?? 0,
        growth_ratio: task.metric_chart.growth_ratio,
      },
    ],
  }));
  return res;
};

export const getLineOrPieData = (arrlist: any[]) => {
  if (!Array.isArray(arrlist)) return [];
  const res = arrlist?.map((task) => ({
    app_id: task.user_info.id,
    id: task.user_info.id,
    image_url: task.user_info.icon,
    name: task.user_info.name,
    ipo_status: task.user_info.market,
    location_identifiers_country_code: task.user_info.market_abbre,
    time_line: task?.metric_time_line?.map((item) => ({
      time: item.Date,
      metric_value_list: [
        {
          data_source: item?.data_source ?? '',
          value: item?.value,
          growth_ratio: item?.growth_ratio ?? 0,
          metric: 'total_revenue',
          growth_vaue: 0,
        },
      ],
    })),
  }));
  return res;
};

export const getKolDetailDbiPageLogMes = (type: string) => {
  switch (type) {
    case 'Twitch':
      return 'streamingInfluencerTwitch';
    case 'Youtube':
      return 'streamingInfluencerYoutube';
    case 'Facebook':
      return 'streamingInfluencerFacebook';
    default:
      return 'streamingInfluencerTwitch';
  }
};

// 跳转下钻页，默认根据url带的平台字段，获取默认平台参数
export const getPlatfromParms = (tab: string) => {
  if (PLATFROM_VALUE_LIST.includes(tab)) {
    return [tab];
  }
  return PLATFROM_VALUE_LIST;
};
